<template>
  <div>
  <el-row>
    <el-row>
      <el-col :span="24">
        <el-select  @change="onSelectJcxm" v-model="$store.state.search.jcxmId" filterable placeholder="请选择所属数据项" size="small" class="headStyle" v-show="showStationSelect" style="width: 20rem;"  >
          <el-option
              v-for="item in jcxmList"
              :key="item.mstp"
              :label="item.mstpNm"
              :value="item.mstp">
          </el-option>
        </el-select>
        <el-select @change="onSelect" @visible-change="onVisible" v-model="$store.state.search.jcdId" filterable placeholder="请选择测站" size="small" class="headStyle" v-show="showStationSelect" style="width: 20rem;"  >
          <el-option
              v-for="item in jczList"
              :key="item.stcd"
              :label="item.stcd"
              :value="item.stcd">
          </el-option>
        </el-select>
  <div class="buttonStyle" >
        <el-button type="text" :class="$store.state.search.fastChoose === 'YESTERDAY' ? 'chooseActive':'choose'"  @click="onFastChoose('YESTERDAY')">昨日</el-button>
        <el-button type="text" :class="$store.state.search.fastChoose === 'TODAY' ? 'chooseActive':'choose'"  @click="onFastChoose('TODAY')">今日</el-button>
        <el-button type="text" :class="$store.state.search.fastChoose === 'LAST_WEEK' ? 'chooseActive':'choose'"  @click="onFastChoose('SZ')">上周</el-button>
        <el-button type="text" :class="$store.state.search.fastChoose === 'THIS_WEEK' ? 'chooseActive':'choose'"  @click="onFastChoose('BZ')">本周</el-button>
        <el-button type="text" :class="$store.state.search.fastChoose === 'LAST_TENCENT' ? 'chooseActive':'choose'"  @click="onFastChoose('LAST_TENCENT')">上旬</el-button>
        <el-button type="text" :class="$store.state.search.fastChoose === 'THIS_TENCENT' ? 'chooseActive':'choose'"  @click="onFastChoose('THIS_TENCENT')">本旬</el-button>
        <el-button type="text" :class="$store.state.search.fastChoose === 'LAST_MONTH' ? 'chooseActive':'choose'"  @click="onFastChoose('LAST_MONTH')">上月</el-button>
        <el-button type="text" :class="$store.state.search.fastChoose === 'THIS_MONTH' ? 'chooseActive':'choose'"  @click="onFastChoose('THIS_MONTH')">本月</el-button>
        <el-button type="text" :class="$store.state.search.fastChoose === 'LAST_SEASON' ? 'chooseActive':'choose'"  @click="onFastChoose('LAST_SEASON')">上季</el-button>
        <el-button type="text" :class="$store.state.search.fastChoose === 'THIS_SEASON' ? 'chooseActive':'choose'"  @click="onFastChoose('THIS_SEASON')">本季</el-button>
        <el-button type="text" :class="$store.state.search.fastChoose === 'LAST_YEAR' ? 'chooseActive':'choose'"  @click="onFastChoose('LAST_YEAR')">去年</el-button>
        <el-button type="text" :class="$store.state.search.fastChoose === 'THIS_YEAR' ? 'chooseActive':'choose'"  @click="onFastChoose('THIS_YEAR')">本年</el-button>
        <el-button type="text" :class="$store.state.search.fastChoose === 'ZDY' ? 'chooseActive':'choose'"  @click="onFastChoose('ZDY')" >自定义</el-button>
  </div>z
        <div class="headStyle" v-show="dateShow">
          <el-date-picker
              v-if="timeMode"
              v-model="$store.state.search.dateValue"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss"
              size="small"
          />
          <el-date-picker
              v-else
              v-model="$store.state.search.dateValue"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              size="small"
          />
        </div>
        <el-button
            type="primary"
            icon="el-icon-search"
            size="mini"
            style="margin-left: 20px"
            class="queryButton "
            @click="search">
          搜索
        </el-button>
<!--        <el-button class="headStyle" type="primary" size="small" v-if="showImport" @click="searchImport">导入</el-button>-->
<!--        <el-button class="headStyle" type="primary" size="small" v-if="showExport" @click="searchExport">导出</el-button>-->

        <el-button
            type="primary"
            size="mini"
            v-if="showExport"
            class="queryButton queryButtonPadding qDcBtn"
            @click="searchExport">
          <el-image class="qDcImg" :src="require('@/assets/buttonGathers/query-dc.png')"></el-image>
          &nbsp;导出
        </el-button>
      </el-col>
    </el-row>
  </el-row>

  </div>
</template>

<script>
export default {
  name: "search",
  data() {
    return {
      dateShow: false,
      // dateVal: ['2021-07-01','2021-07-15'],
      // fastChoose: 'JR',
      // jcdVal: null,
      showAll:false,
      jcxmVal:'',
      czVal:'',
      // czList:[],
    }
  },
  methods: {
    onVisible(val){
      if(val){
        // if(this.$store.state.search.jcxmId===''){
        //   this.$message.error("请先选择监测所属数据项！")
        // }
      }
    },
    searchImport(){
      this.$emit('searchImport');
    },
    searchExport(){
      this.$emit('download');
    },
    onSelect(selected){
      const selectedOption = this.jczList.find(option =>
          option.stcd === selected
      );
      let selectedLabel = '';
      if (selectedOption) {
        selectedLabel = selectedOption.stcd;
      }
      this.$store.state.search.jcdId=selected;
      this.$store.state.search.jcd=selectedLabel;
      this.$store.commit({
        type:'onJcdSelect',
        value:selected
      });
      this.$emit('query');
    },
    onSelectJcxm(selected){
     if(selected){
       const selectedOption = this.jcxmList.find(option =>
         option.mstp === selected
       );
       let selectedLabel = '';
       if (selectedOption) {
         selectedLabel = selectedOption.mstpNm;
       }

       this.$store.state.search.jcxmId=selected;
       this.$store.state.search.jcxm=selectedLabel;
       this.getCzList(selected);
       this.$emit('query');
     }else{
       this.jczList=[];
     }
    },
    onFastChoose(choosed) {
      this.$store.commit({
        type:'onFastChooseChange',
        value:choosed
      });
      if('ZDY' !== choosed){
        if(this.dateShow){
          this.dateShow = false;
        }
        this.$emit('query');
      }else{
        if(!this.dateShow){
          this.dateShow = true;
        }
      }
    },

    search(){
      // this.query(this.jcdVal,this.dateVal,this.fastChoose);
      if(this.dateShow && !this.$store.state.search.dateValue){
          this.$message.warning('请先选择时间再查询！');
          return;
      }
      this.$emit('query');
    },
    // query(jcdId,searchTime,queryDateType){
    //     if(this.dateShow && !this.dateVal){
    //       this.$message.warning('请先选择时间再查询！');
    //       return;
    //     }
    //     this.$emit('query',[jcdId,searchTime,queryDateType]);
    // },
  },
  props:['jcxmList','jczList','getCzList','showAllStations','showStationSelect','timeMode','showImport','showExport']
}
</script>

<style scoped>
 .chooseActive{
    color:#409EFF;
    margin-left: 2rem;
    float: left;
  }
  .choose{
    color:#909399;
    margin-left: 2rem;
    float: left;
  }
  .headStyle{
    margin-left: 1rem;
    float: left;
  }

  /deep/ .buttonStyle .el-button--text {
    background: 0 0;
    padding-left: 0;
    padding-right: 0;
    padding-top: 6px;
  }


</style>
